var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.667,
    cy: 12,
    r: 9,
    stroke: "#89888D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93337 9.0396C9.46853 9.30107 9.1193 9.57762 8.85196 9.83909C8.50273 9.43934 8.06921 8.65745 8.06921 8.08423C8.06921 7.33753 9.18433 6 13.5244 6C16.3857 6 17.667 7.4406 17.667 9.59522C17.667 12.1471 15.8534 14.1106 12.0263 14.3545C11.5928 17.6028 11.0943 18 9.6299 18C8.73154 18 8.03308 17.653 7.66699 17.0974C8.91458 15.5336 9.64676 11.7825 9.92855 9.0396H9.93337ZM12.2792 12.0088C13.9772 11.8001 14.6082 10.983 14.6082 9.64802C14.6082 8.86612 14.1602 8.2577 13.2619 8.2577C13.0451 8.2577 12.8284 8.2753 12.6309 8.2929C12.5297 9.68322 12.3804 10.9679 12.2816 12.0088H12.2792Z",
    fill: "#89888D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnlock);
export default __webpack_public_path__ + "static/media/profile_unlock.b033ef3471e8ec16f196fc60aea823ae.svg";
export { ForwardRef as ReactComponent };